export const CHANGE_PAGE = 'textbook/CHANGE_PAGE';
export const CHANGE_LEVEL = 'textbook/CHANGE_LEVEL';
export const UPDATE_WORDS = 'textbook/UPDATE_WORDS';
export const PENDING_TRUE = 'textbook/PENDING_TRUE';
export const PENDING_FALSE = 'textbook/PENDING_FALSE';
export const FETCH_ERROR = 'textbook/FETCH_ERROR';
